{
  "RequestAvailabilityDialog": {
    "title": "Poproś o dostępność",
    "viaEmail": "E-mail",
    "viaLink": "Link",
    "requestedDates": "Żądane daty",
    "requestedDatesHelper": "Zasoby uzupełnią dostępność w tym zakresie dat",
    "addMessage": "Dodaj wiadomość",
    "addMessageHelper": "Wiadomość zostanie dołączona do e-maila",
    "messagePlaceholder": "Zacznij pisać...",
    "next": "Dalej",
    "generateLink": "Wygeneruj link",
    "generatedUrl": "Wygenerowany URL",
    "urlExpiresOn": "Ten URL wygaśnie {{date}}",
    "done": "Gotowe",
    "copyUrl": "Kopiuj URL",
    "copied": "Skopiowano",
    "back": "Wstecz",
    "recipients": "Odbiorcy",
    "recipientsHelper": "Potwierdź, kto ma otrzymać prośbę o dostępność",
    "searchPlaceholder": "Szukaj i dodaj zasoby",
    "noSearchResults": "Nie znaleziono zasobów",
    "noRecipients": "Dodaj co najmniej jednego odbiorcę",
    "missingEmailsMessage": "Brak e-maila dla tych zasobów. Dodaj go poniżej.",
    "recipientsCount": "{{count}} odbiorca",
    "recipientsCount_few": "{{count}} odbiorcy",
    "recipientsCount_many": "{{count}} odbiorców",
    "recipientsCount_other": "{{count}} odbiorców",
    "removeRecipient": "Usuń odbiorcę",
    "email": "E-mail",
    "noEmail": "Brak e-maila",
    "addEmail": "Dodaj e-mail",
    "saveEmail": "Zapisz e-mail",
    "resourceEmail": "E-mail zasobu",
    "emailPlaceholder": "Wpisz e-mail",
    "confirmAndSend": "Potwierdź i wyślij",
    "emailPreviewTitle": "Podgląd e-maila",
    "emailPreviewHelper": "Sprawdź prośbę, którą wyślemy",
    "emailPreviewGreeting": "Cześć {{name}},",
    "emailPreviewBody": "{{sender}} z firmy {{company}} chce wiedzieć, kiedy będziesz następny raz dostępny.",
    "emailPreviewDatesLabel": "Żądane daty",
    "emailPreviewDateRange": "Od <start>{{startDate}}</start> do <end>{{endDate}}</end>",
    "emailPreviewCtaHint": "Kliknij link poniżej, aby podać swoją dostępność.",
    "emailPreviewShareButton": "Podaj dostępność",
    "emailPreviewExpiry": "Ten URL będzie aktywny przez 28 dni, po czym wygaśnie. Jeśli wygaśnie, skontaktuj się z osobą wysyłającą prośbę o nowy link.",
    "sending": "Wysyłanie…",
    "sendSuccessTitle": "Wysłano {{count}} prośbę",
    "sendSuccessTitle_few": "Wysłano {{count}} prośby",
    "sendSuccessTitle_many": "Wysłano {{count}} próśb",
    "sendSuccessTitle_other": "Wysłano {{count}} próśb",
    "unsavedChangesBeforeUnload": "Masz niezapisane zmiany w formularzu prośby o dostępność!",
    "dateRangeRequired": "Wybierz zakres dat",
    "resourceRequired": "Wybierz zasób",
    "emailRequired": "Każdy odbiorca potrzebuje adresu e-mail"
  }
}
